/* build-your-own-bundle.js
   Save into your theme's /assets folder with this exact filename. */

window.BuildYourOwnBundle = (function () {
  function getTierLabel(totalQty) {
    if (totalQty >= 8) return '8% off applied at checkout';
    if (totalQty >= 6) return '6% off applied at checkout';
    if (totalQty >= 4) return '4% off applied at checkout';
    return '';
  }

  function init(sectionId) {
    var root = document.getElementById('byo-' + sectionId);
    if (!root) return;

    var cards = root.querySelectorAll('[data-byo-card]');
    var countEl = root.querySelector('[data-byo-count]');
    var tierBadgeEl = root.querySelector('[data-byo-tier-badge]');
    var addAllBtn = document.getElementById('byo-add-all-' + sectionId);

    cards.forEach(function (card) {
      var variantsScript = card.querySelector('[data-byo-variants]');
      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }

      var selectedOptions = [];
      var variantIdInput = card.querySelector('[data-byo-variant-id]');
      var priceEl = card.querySelector('[data-byo-price]');
      var includeCheckbox = card.querySelector('[data-byo-include]');
      var qtyInput = card.querySelector('[data-byo-qty-input]');

      // Track initially selected options from the pills marked is-selected
      card.querySelectorAll('[data-byo-option-index]').forEach(function (group) {
        if (!group.hasAttribute('data-value')) {
          var idx = parseInt(group.getAttribute('data-byo-option-index'), 10);
          var selectedPill = group.querySelector('.is-selected');
          selectedOptions[idx] = selectedPill ? selectedPill.getAttribute('data-value') : null;
        }
      });

      function updateVariant() {
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
        });
        if (!match) return;
        variantIdInput.value = match.id;
        if (priceEl && window.Shopify && window.Shopify.formatMoney) {
          priceEl.textContent = window.Shopify.formatMoney(match.price, window.Shopify.money_format);
        }
      }

      card.querySelectorAll('.byo__option-values').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-byo-option-index'), 10);
        group.querySelectorAll('.byo__option-pill').forEach(function (pill) {
          pill.addEventListener('click', function () {
            group.querySelectorAll('.byo__option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
            pill.classList.add('is-selected');
            selectedOptions[idx] = pill.getAttribute('data-value');
            updateVariant();
          });
        });
      });

      card.querySelectorAll('[data-byo-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10) || 1;
          var next = btn.getAttribute('data-byo-qty') === 'plus' ? current + 1 : Math.max(1, current - 1);
          qtyInput.value = next;
          updateSummary();
        });
      });
      qtyInput.addEventListener('change', updateSummary);

      includeCheckbox.addEventListener('change', function () {
        card.classList.toggle('is-excluded', !includeCheckbox.checked);
        updateSummary();
      });
    });

    function updateSummary() {
      var total = 0;
      cards.forEach(function (card) {
        var include = card.querySelector('[data-byo-include]');
        var qty = card.querySelector('[data-byo-qty-input]');
        if (include.checked) total += parseInt(qty.value, 10) || 0;
      });
      if (countEl) countEl.textContent = total;
      if (tierBadgeEl) tierBadgeEl.textContent = getTierLabel(total);
      if (addAllBtn) addAllBtn.disabled = total === 0;
    }

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var items = [];
        cards.forEach(function (card) {
          var include = card.querySelector('[data-byo-include]');
          if (!include.checked) return;
          var variantId = card.querySelector('[data-byo-variant-id]').value;
          var qty = parseInt(card.querySelector('[data-byo-qty-input]').value, 10) || 1;
          if (variantId) items.push({ id: variantId, quantity: qty });
        });

        if (items.length === 0) return;

        var originalText = addAllBtn.textContent;
        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            addAllBtn.textContent = 'Added OK';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              addAllBtn.textContent = originalText;
              addAllBtn.disabled = false;
            }, 1800);
          })
          .catch(function () {
            addAllBtn.textContent = 'Something went wrong';
            setTimeout(function () {
              addAllBtn.textContent = originalText;
              addAllBtn.disabled = false;
            }, 1800);
          });
      });
    }

    updateSummary();
  }

  return { init: init };
})();